import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import StockTransferenciasDetailTab from "./components/StockTransferenciasDetailTab";

const PURCHASE_TABS = [{ id: "detalle", label: "Detalle de compras" }];

const StockComprasDetallePage = () => {
  const [activeTab, setActiveTab] = useState("detalle");

  useEffect(() => {
    document.title = "Stock - Compras | Saas";
  }, []);

  const renderTabContent = (tabId: string) => {
    switch (tabId) {
      case "detalle":
        return <StockTransferenciasDetailTab mode="compras" />;
      default:
        return null;
    }
  };

  return (
    <div className="page-content">
      <Container fluid className="px-2 px-md-3">
        <BreadCrumb title="Stock - Compras" pageTitle="Informes" />
        <Card className="border-0 shadow-sm">
          <CardBody className="pb-2">
            <Nav pills className="arrow-navtabs nav-success mb-3">
              {PURCHASE_TABS.map((tab) => (
                <NavItem key={tab.id}>
                  <NavLink
                    href="#"
                    className={classNames({ active: activeTab === tab.id })}
                    onClick={(event) => {
                      event.preventDefault();
                      setActiveTab(tab.id);
                    }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab} className="pt-2">
              {PURCHASE_TABS.map((tab) => (
                <TabPane tabId={tab.id} key={tab.id}>
                  {renderTabContent(tab.id)}
                </TabPane>
              ))}
            </TabContent>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default StockComprasDetallePage;
